import React from "react";
import HorizontalBarChart from "./HorizontalBarChart";

const EngagementMetrics = ({ videos }) => {
  const totalViews = videos.reduce((sum, v) => sum + (v.video?.count_views || 0), 0);
  const totalLikes = videos.reduce((sum, v) => sum + (v.video?.count_likes || 0), 0);
  const totalComments = videos.reduce((sum, v) => sum + (v.video?.count_comments || 0), 0);

  const avgEngagement = totalViews > 0
    ? ((totalLikes + totalComments) / totalViews * 100)
    : 0;

  const metrics = [
    { label: 'Total Views', value: totalViews, color: '#3b82f6' },
    { label: 'Total Likes', value: totalLikes, color: '#ef4444' },
    { label: 'Total Comments', value: totalComments, color: '#22c55e' },
  ];

  const maxValue = Math.max(...metrics.map(m => m.value));

  return (
    <div className="space-y-6">
      <div className="text-center p-4 bg-theme-main rounded-xl">
        <div className="text-3xl font-bold text-theme-text">{avgEngagement.toFixed(2)}%</div>
        <div className="text-sm text-theme-text opacity-50">Avg Engagement Rate</div>
      </div>
      <HorizontalBarChart data={metrics} maxValue={maxValue} />
    </div>
  );
};

export default EngagementMetrics;
